export default "<ng-template #progressSpinnerRef>\r\n        <mat-spinner></mat-spinner>\r\n</ng-template>"